import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const newsApi = createApi({
  reducerPath: 'newsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getNews: builder.query({
      query(req) {
        return {
          url: urls.news(req.categories, req.page, req.isEnglish),
          method: 'GET',
        };
      },
    }),
    getNormalNews: builder.query({
      query: () => ({
        url: urls.newsNormal,
      }),
    }),
    getArchiveNews: builder.query({
      query(isEnglish = false) {
        return {
          url: urls.newsArchive(isEnglish),
          method: 'GET',
        };
      },
    }),
    getNewsDetail: builder.query({
      query(id) {
        return {
          url: urls.newsDetail(id),
          method: 'GET',
        };
      },
    }),
    getNewsCategories: builder.query({
      query() {
        return {
          url: urls.newsCategories,
          method: 'GET',
        };
      },
    }),
    getNewsCategoryDetail: builder.query({
      query(id) {
        return {
          url: urls.newsCategory(id),
          method: 'GET',
        };
      },
    }),
    getNewsEdit: builder.query({
      query() {
        return {
          url: urls.newsEdit,
          method: 'GET',
        };
      },
    }),
    saveNews: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.newsDetail(req.id, true),
            method: 'PUT',
            data: req.data,
          };
        } else {
          return {
            url: urls.news(null, null, true),
            method: 'POST',
            data: req.data,
          };
        }
      },
    }),
    saveNewsCategory: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.newsCategory(req.id),
            method: 'PUT',
            data: req.data,
          };
        } else {
          return {
            url: urls.newsCategories,
            method: 'POST',
            data: req.data,
          };
        }
      },
    }),
    deleteNews: builder.mutation({
      query(id) {
        return {
          url: urls.newsDetail(id),
          method: 'DELETE',
        };
      },
    }),
    deleteNewsCategory: builder.mutation({
      query(id) {
        return {
          url: urls.newsCategory(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetNewsQuery,
  useGetNormalNewsQuery,
  useLazyGetNewsQuery,
  useGetArchiveNewsQuery,
  useGetNewsDetailQuery,
  useGetNewsCategoriesQuery,
  useGetNewsCategoryDetailQuery,
  useGetNewsEditQuery,
  useSaveNewsMutation,
  useSaveNewsCategoryMutation,
  useDeleteNewsMutation,
  useDeleteNewsCategoryMutation,
} = newsApi;
